<template>
  <UiInputPhoneVeeBase
    v-bind="{ ...$props, ...$attrs, modelValue: $props.modelValue ?? null }" />
</template>

<script lang="ts">
import type { PropType } from 'vue'
import type { TValidationRules } from '@team-milva/lab-components'
import type { PhoneNumberMeta } from '@team-milva/utils/phone'

export default {
  name: 'UiInputPhoneVee',
  inheritAttrs: false,
  props: {
    name: { type: String, required: true as const },
    label: { type: String, default: undefined },
    rules: { type: Array as PropType<TValidationRules[]>, default: undefined },
    modelValue: { type: Object as PropType<PhoneNumberMeta | null>, required: false as const, default: null },
    showAsRequired: { type: Boolean, default: undefined },
    isRequired: { type: Boolean, default: undefined },
    isDisabled: { type: Boolean, default: undefined },
  },
}
</script>

